export const checkEmail = (email: string): boolean => {
    const regExp = /^.{1,}@.{1,}\..{1,}/;
    return regExp.test(email);
};
export const checkPassword = (password: string): boolean => {
    const regExp = /.{8,}/;
    return regExp.test(password);
};
